// extracted by mini-css-extract-plugin
export default {"wrapper":"rGEYMp3nLWSukMjoYOXP","text":"XURDbz2Mhb7nygUZrHIX","picture":"mKcKBNZctkNf6gaqnjvv","pin":"PdIf7vNKKqoHFcVAmiHq"};